// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"2f507f72","35":"d598240c","158":"d7d64e4e","217":"7e7938f9","488":"55aa4999","661":"15ec01d5","766":"497f071d","815":"60b7c7bc","899":"c2fcf685"}[chunkId] + ".chunk.js";
};